var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPresentationThemePromo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 464,
  height: 160,
  viewBox: "0 0 464 160",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#182229",
  d: "M240 0h224v160H240z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M258.939 79.139a2.939 2.939 0 0 1 0-5.878h53.4a2.939 2.939 0 0 1 0 5.878zM258.939 92.102a2.939 2.939 0 0 1 0-5.878h37.024a2.939 2.939 0 1 1 0 5.878z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(373 40)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E6EBF0",
  d: "M0 83h75v7H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3A5A98",
  d: "M0 0h75v9H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 9h75v74H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0DAE1",
  d: "M6 35h63v42H6z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 6,
  y: 15,
  fill: "#D0DAE1",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 2,
  x: 14,
  y: 17,
  fill: "#D0DAE1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 2,
  x: 6,
  y: 27,
  fill: "#D0DAE1",
  rx: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3A5A98",
  d: "M373 140h75v9h-75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M373 149h75v11h-75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#182229",
  fillOpacity: 0.7,
  d: "M240 0h224v160H240z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#16E3B3",
  d: "m345.433 80.996 3.967 5.625c.348.493.93.506 1.299.033 0 0 7.211-9.28 7.868-10.004 1.313-1.448-.657-3.62-1.97-2.172-.657.724-6.567 7.513-6.567 7.513s-1.97-2.444-2.627-3.168c-1.313-1.448-3.283.724-1.97 2.173"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M18.945 92C17.32 92 16 90.657 16 89s1.319-3 2.945-3h37.11C57.68 86 59 87.343 59 89s-1.319 3-2.945 3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M18.945 92C17.32 92 16 90.657 16 89s1.319-3 2.945-3h37.11C57.68 86 59 87.343 59 89s-1.319 3-2.945 3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#16E3B3",
  d: "M0 0h224v160H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h224v20H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 4,
  fill: "#6F7D89"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#16C29A",
  fillOpacity: 0.5,
  d: "m153.997 69 .003-.111c0-4.97-4.003-9-8.94-9-.742 0-1.463.093-2.152.264-.655-8.478-7.69-15.153-16.28-15.153-6.42 0-11.97 3.729-14.64 9.15-.305-.023-.612-.039-.923-.039-4.919 0-9.134 3.029-10.91 7.334h-.016C95.85 61.444 92.338 64.77 92 69zM86.999 48l.001-.046c0-2.071-1.614-3.75-3.605-3.75q-.45.001-.868.11C82.263 40.78 79.427 38 75.963 38c-2.588 0-4.827 1.554-5.904 3.813a5 5 0 0 0-.371-.017c-1.984 0-3.684 1.262-4.4 3.056h-.006c-1.73 0-3.146 1.386-3.282 3.148z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.939 79.139a2.939 2.939 0 0 1 0-5.878h53.4a2.939 2.939 0 0 1 0 5.878zM18.939 92.102a2.939 2.939 0 0 1 0-5.878h37.024a2.939 2.939 0 1 1 0 5.878z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#16C29A",
  fillOpacity: 0.5,
  d: "M0 145.39c13.58-.138 11.631-16.611 34.59-16.611 22.957 0 22.173 16.611 50.57 16.611S115.573 96.894 150.302 97s27.412 48.39 73.6 48.39q.195 0 0 14.61H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(133 40)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E6EBF0",
  d: "M0 83h75v7H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3A5A98",
  d: "M0 0h75v9H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 9h75v74H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0DAE1",
  d: "M6 35h63v42H6z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 6,
  y: 15,
  fill: "#D0DAE1",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 2,
  x: 14,
  y: 17,
  fill: "#D0DAE1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 2,
  x: 6,
  y: 27,
  fill: "#D0DAE1",
  rx: 1
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3A5A98",
  d: "M133 140h75v9h-75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M133 149h75v11h-75z"
})))));
export default SvgPresentationThemePromo;